module.exports = __webpack_public_path__ + "static/media/Deterra-Ranger.f9388d6a.png";